
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joy-ui/react-input",
      function () {
        return require("private-next-pages/joy-ui/react-input.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joy-ui/react-input"])
      });
    }
  